import markerclusterer_Image1 from '../../../assets/images/ic_store_markercluster1.png';
import markerclusterer_Image2 from '../../../assets/images/ic_store_markercluster2.png';
import markerclusterer_Image3 from '../../../assets/images/ic_store_markercluster3.png';
import markerclusterer_Image4 from '../../../assets/images/ic_store_markercluster4.png';
import markerclusterer_Image5 from '../../../assets/images/ic_store_markercluster5.png';

import {Cluster} from "@googlemaps/markerclusterer/dist/cluster";
import {DefaultRenderer} from "@googlemaps/markerclusterer";

import {createMarkerContent} from "./marker-content";

export class CustomRenderer implements DefaultRenderer {

  // =========================
  // 🔹 CLUSTER STYLE RESOLUTION
  // =========================

  private getImageAndSize(count: number): { image: string, size: number } {
    switch (true) {
      case (count >= 2 && count < 10):
        return {image: markerclusterer_Image1, size: 30};
      case (count >= 10 && count < 50):
        return {image: markerclusterer_Image2, size: 40};
      case (count >= 50 && count < 100):
        return {image: markerclusterer_Image3, size: 50};
      case (count >= 100 && count < 200):
        return {image: markerclusterer_Image4, size: 60};
      case (count >= 200):
        return {image: markerclusterer_Image5, size: 80};
      default:
        return {image: '', size: 0};
    }
  }

  // =========================
  // 🔹 CLUSTER RENDERING
  // =========================

  render({count, position}: Cluster): google.maps.marker.AdvancedMarkerElement {
    const {image, size} = this.getImageAndSize(count);

    return new google.maps.marker.AdvancedMarkerElement({
      position: position,
      content: createMarkerContent(image, size, count),
      zIndex: count
    });
  }
}